import {CalendarPage} from "./pages/CalendarPage.jsx";
import '../../css/default.css'
import 'react-toastify/dist/ReactToastify.css';


function ProvidedApp(props) {
    const {tasks, small, onOpenChange, onTaskEditingChange} = props
    return (<div>
        <CalendarPage small={small} onOpenChange={onOpenChange} onTaskEditingChange={onTaskEditingChange}
                      tasks={tasks}/>
    </div>)
}

export function CalendarCustom(props) {
    const {tasks, small, onOpenChange, onTaskEditingChange} = props
    return (
        <ProvidedApp small={small} onOpenChange={onOpenChange} onTaskEditingChange={onTaskEditingChange} tasks={tasks}/>
    );
}


